require('./mortgageRequestSimpleNote.scss');

// @ vendors
const React = require('react');

// @ components
const OKModal = require('components/commons/OKModal/OKModal');

const modal = onRequestClose => (
    <OKModal
        footerType="action"
        isOpen={true}
        onCloseCallback={onRequestClose}
        onPrimaryButtonClick={onRequestClose}
        primaryButtonText="mortgageRequestCommons-acceptButtonText"
        title="mortgageRequestEstates-livingPlaceErrorModal"
    />
);

module.exports = modal;
